
























import { Component, Vue } from 'vue-property-decorator';
import PlanUserSearch from './search.vue';
import PlanUserAction from './action.vue';
import PlanUserTable from './table.vue';
import { RecordStatusCheckbox } from '@/components/record';
import { Pagination } from '@/components/form';
import { PlanRecordDialog } from '@/components/plan';
import { RecordTemplateDialog } from '@/components/record';
import { RecordCreateDialog } from '@/components/record';
import { PlanEditDialog } from '@/components/plan';
import { CourseChangeDialog } from '@/components/course';

import { Load } from '@/domains/system';
import { Record, Plan } from '@/domains/work';
import { Supervisor, SupervisorGroup } from '@/domains/supervisor';
import { Person, Profession } from '@/domains/person';
import { CourseGroup, CoursePlanExec, CoursePlan, Course } from '@/domains/course';
import { Department } from '@/domains/department';
import { Campus } from '@/domains/campus';
import { Page } from '@/domains/page';
import { Getter } from 'vuex-class';
import { Now } from '@/domains/date';

@Component({
  name: 'PlanUserPage',
  components: {
    PlanUserSearch,
    PlanUserAction,
    PlanUserTable,
    RecordStatusCheckbox,
    Pagination,
    PlanRecordDialog,
    RecordCreateDialog,
    RecordTemplateDialog,
    PlanEditDialog,
    CourseChangeDialog,
  },
})
export default class PlanUserPage extends Vue {
  @Getter private now: Now;

  @Getter private supervisor: Supervisor;

  /** 加载 */
  private load: Load = new Load();

  /** 表单 */
  private form: Record = null;

  /** bus */
  private bus: Vue = new Vue();

  /** 计划列表 */
  private plans: Plan[] = [];

  /** 初始化表单 */
  private initForm(): void {
    const form: Record = new Record();
    const plan: Plan = new Plan();
    const supervisor: Supervisor = new Supervisor();
    const person: Person = new Person();
    const supervisorCourseGroup: CourseGroup = new CourseGroup();
    const supervisorGroup: SupervisorGroup = new SupervisorGroup();
    const coursePlan: CoursePlanExec = new CoursePlanExec();
    const clazz: CoursePlan = new CoursePlan();
    const department: Department = new Department();
    const courseGroup: CourseGroup = new CourseGroup();
    const course: Course = new Course();
    const teacher: Person = new Person();
    const profession: Profession = new Profession();
    const campus: Campus = new Campus();
    const page: Page = new Page();

    form.plan = plan;
    plan.supervisor = supervisor;
    plan.coursePlan = coursePlan;
    supervisor.person = person;
    supervisor.courseGroup = supervisorCourseGroup;
    supervisor.supervisorGroup = supervisorGroup;
    coursePlan.clazz = clazz;
    coursePlan.teacher = teacher;
    coursePlan.campus = campus;
    clazz.department = department;
    clazz.course = course;
    department.courseGroup = courseGroup;
    teacher.profession = profession;

    form.pageInfo = page;

    form.deleted = false;
    form.statusList = [1, 2];
    plan.deleted = false;
    clazz.year = this.now.year.year;
    clazz.term = this.now.year.term;
    person.id = this.supervisor.person.id;

    this.form = form;
  }

  private created() {
    this.initForm();
  }

  private mounted() {
    this.bus.$on('plan-user-initForm', () => { this.initForm(); });
    this.$nextTick(() => { this.bus.$emit('plan-user-search'); });
  }
}
